import React, {Component} from 'react';



export default class Spinner extends Component {
	render() {
		return(
			<div className="dashboard-wrapper">
			    <div className="container-fluid  dashboard-content" style={{textAlign : 'center', paddingTop : this.props.pt ? this.props.pt : "200px"}}>
			        <span className="dashboard-spinner spinner-xxl"></span>
			    </div>
			</div>
		)
	}
}


